export default function Buttons(options){
    let container = options.container
    let elements = {
        main_container: {
            container:undefined
        },
        clear_button:{
            container: undefined,
            button: undefined,
            func: options.clear_func
        },
        only_selected_button:{
            container: undefined,
            button: undefined,
            func: options.only_selected_func,
            status: false
        }
    }
    let only_selected_button;
    this.generate = () =>{
        //gerando elementos html
        generateMainContainer()
        generateClearButton()
        generateOnlySelectedButton()
        
        //montando elementos no container principal
        mountAll()

        //appendando container criado no container passado como parametro
        $(container).append(elements.main_container.container)
    }

    this.getSelectedStatus = () =>{
        return only_selected_button.getStatus()
    }

    function generateClearButton(){
        let element = document.createElement("div")
        element.classList.add("clear-button-container")
        elements.clear_button.container = element

        element = document.createElement("button")
        element.classList.add("clear-button")
        element.innerHTML = "Limpar seleções"
        elements.clear_button.button = element
        element.addEventListener('click', ()=>elements.clear_button.func())

        elements.clear_button.container.appendChild(element)
    }

    function generateOnlySelectedButton(){
        let element = document.createElement("div")
        element.classList.add("only-selected-button-container")
        elements.only_selected_button.container = element

        only_selected_button = new Button({text: 'Selecionados <i class="far fa-check-circle"></i>', title: 'Mostrar apenas postos selecionados'})
        only_selected_button.generate()
        elements.only_selected_button.container.appendChild(only_selected_button.getElement())
    }

    function generateMainContainer(){
        let element = document.createElement('div')
        element.classList.add('stations-list-action-buttons-container')
        elements.main_container.container = element
    }

    function mountAll(){
        elements.main_container.container.appendChild(elements.clear_button.container)
        elements.main_container.container.appendChild(elements.only_selected_button.container)
    }

    function Button(options){
        let element = undefined
        let status = false
        let state = 'default'
        this.text = options.text
        let title = options.title

        this.generate = () =>{
            element = (!element) ? document.createElement("button") : element
            element.classList.add("only-selected-button")
            $(element).toggleClass("active", status)
            
            element.innerHTML = options.text
            
            if(title){
                element.title = title
            }

            $(element).off()
            $(element).on('click', ()=>{
                //alterando status do botao
                this.setStatus(!status)
                //executando função callback passada como parâmetro
                elements.only_selected_button.func()
            })
        }

        this.getElement = () =>{
            return element
        }

        this.setStatus = (new_status) =>{
            status = new_status
            this.updateButton()
        }

        this.getStatus = () =>{
            return status
        }

        this.setState = (state) =>{
            this.state = state
            this.updateButton()
        }

        this.updateButton = () =>{
            // $(element).toggleClass("active", this.getStatus())
            this.generate(0)
        }
    }
}